import React from 'react'
import Slider from 'react-slick'
import styled from '@xstyled/styled-components'
import './external-lib-styles/slick-theme.css'
import './external-lib-styles/slick.css'

const DEFAULTS = {
  dots: true,
  arrows: true,
  infinite: true,
  speed: 500,
  slidesToShow: 1,
  autoplay: true,
  autoplaySpeed: 4000,
  slidesToScroll: 1
}

export const Carousel = React.forwardRef(({ children, settings = {} }, ref) => {
  const config = Object.assign({}, DEFAULTS, settings)
  return (
    <Root ref={ref} {...config}>
      {children}
    </Root>
  )
})

const Root = styled(Slider)`
  .slick-dots li button:before {
    font-size: 20px;
  }

  .slick-prev {
    left: -4%;
    z-index: 1;

    &::before {
      color: black;
      font-size: 30px;
    }
  }

  .slick-next {
    z-index: 1;

    &::before {
      color: black;
      font-size: 30px;
    }
  }
`
